exports.WhModal = require('./modal_component')